export const pink = {
  backgroundColor: '#F8BBD0',
  fontColor: '#880E4F',
  second: '#880E4F30',

  card: {
    backgroundColor: '#FCE4EC',
    fontColor: '#880E4F',
    shadow: '0 0.5rem 2rem -1rem #191e2790',
  },
  nav: {
    background: '#880E4F',
    fontColor: '#FCE4EC',
    shadow: '0 0 3rem -1rem #191e2770',
  },
  accent: {
    blue: '#2196f3',
    red: '#f44336',
    yellow: '#ffeb3b',
    green: '#81c784',
  },
  borderRadius: 1,
};
